/**
 * 이상한 방 - 바꾸기 띠 (사람 체인저의 하단 도구 띠, 순수 DOM)
 *
 * 근거 문서: `이상한방-컨셉시트-v0.1.md` 3절(바꾸기 1분) · 4.2절(동사 팔레트 → 즉시 실행) · 4.3절(거부는 선택 불가)
 *            `gameHud.css` 머리말(화면 중앙은 비운다 · 누르는 것은 44px · 색은 `--gh-*`)
 *            로드맵 M4(`changerBar` - 예산 점 · 동사 팔레트 · 카탈로그 스트립 · 색 팔레트 · [되돌리기] [다 했다])
 *            로드맵 M7([다 했다] 옆에 "못 찾을 개수" 스테퍼 0..budget - 0이면 걸지 않는다 → `commitChanges{wager}`)
 *
 * ## 이 띠는 계산하지 않는다
 *
 * 받은 뷰(`ChangerBarView`)를 그린다. 어느 동사가 잠겼는지, 몇 개를 만들었는지, 몇 개가 남았는지(`left`), 되돌릴 것이 있는지는
 * 전부 도구(`input/changerTool.ts`)가 `core/verbs`로 미리 검사해 내린 값이다. 여기서 `budget - used`를 다시 세거나 `rotSymmetry`를
 * 보기 시작하면 규칙이 화면에 두 벌째로 생긴다(`gameHud.ts`·`playerStrip.ts`와 같은 규약).
 *
 * ## 남은 시간은 그리지 않는다
 *
 * HUD의 페이즈 시계가 이미 바꾸기 60초를 세고 있다. 같은 값을 두 자리에 그리면 보간 한 틱 차이로 두 숫자가 어긋나는
 * 순간이 생기고, 그 어긋남은 계기판 불신으로 읽힌다. 이 띠가 세는 것은 **개수**(예산 점)만이다.
 *
 * ## 잠긴 버튼은 이유를 말한다 - 눈으로 보는 사람에게도
 *
 * 4.3절의 "선택 불가"는 버튼을 지우는 것이 아니다. 자리가 바뀌면 손가락이 헛디딘다. 잠긴 버튼은 제자리에 남고 왜
 * 안 되는지를 말한다(GLOSSARY 3절). 이유 문구는 `editor.reject.*`(verbs의 사유)와 `changer.lock.*`(예산 · 고른 것
 * 없음) 둘뿐이다.
 *
 * **`disabled`가 아니라 `aria-disabled`다.** `disabled`면 클릭 이벤트 자체가 오지 않아 그 이유를 말할 기회가 없고,
 * 실제로 이유는 `aria-label`에만 있었다 - 눈으로 보는 사람에게는 회색 버튼 다섯뿐이었고 그 화면이 "왜 아무것도
 * 안 되지"로 읽혔다. 이제 눌리기는 하고(누른 뜻은 도구가 `lockFor`로 다시 걸러 버린다) 이유가 자막으로 뜬다.
 * 초점 순서에도 남으므로 보조기술 쪽도 손해가 없다 - 찾아가서 왜인지 들을 수 있다.
 *
 * 이 띠의 힌트 줄(`.cb-hint`)에 적지 않는 이유는 그 줄이 **물건을 고르면 숨기 때문**이다(색 팔레트가 그 자리를
 * 쓴다). 잠금이 문제가 되는 순간이 정확히 그때라 거기 적으면 아무도 못 본다.
 *
 * ## 이름표가 "여기가 내 것"을 말한다 (M11)
 *
 * 여럿이서는 전원이 **자기 구획만** 고친다. 남의 구획 물건은 애초에 골라지지 않으므로(도구가 막는다) 왜 안 눌리는지를
 * 화면이 먼저 말해야 한다 - 그 자리가 띠 왼쪽 위의 이름표("내 구획 · 거실")다. 이름은 구획 id로 사전을 조회한 것이고
 * (`i18n/zoneName.ts`) 그 id는 호스트가 배정한 값 그대로다. 구획이 없는 판이면 이름표가 서지 않는다.
 *
 * ## 걸기 스테퍼(M7)는 이 띠의 유일한 입력 상태다
 *
 * "못 찾을 개수"는 뷰에서 오는 값이 아니라 사람이 고르는 값이라 띠가 든다(폼 입력과 같다 - 규칙이 아니다). 상한은 뷰의
 * `budget`(**내** 예산 = 이 라운드에 내가 만들 개수, M11)이고 거기까지만 누를 수 있게 잠근다 - 그 위는 내 구획에 있지도
 * 않은 개수라 언제나 틀리는 걸기이고 고를 뜻이 없다.
 * 값의 규칙(1 이상 · 개수 이하 · 정수)은 호스트의 `raise.normalizeWager`가 접는다. 여기서 하는 클램프는 규칙의 사본이 아니라
 * 누를 수 있는 단추의 범위다. 0은 "안 건다"이고 [다 했다]가 그 값을 그대로 `onCommit(wager)`로 넘긴다 - `null`로 바꾸는 것은
 * 도구(`changerTool.commit`)의 몫이다.
 *
 * ## 자리: 하단 띠. 오른쪽은 비운다
 *
 * 화면 중앙은 방의 것이다. 띠는 아래에 붙고, 오른쪽 열은 조작 레이어(시점 회전 · 줌, `hud.css`의 `.mc-cluster`)가 쓰므로
 * 그 폭만큼 비운다 - 두 레이어는 서로의 마운트 순서를 모르므로 좌표 규약으로만 푼다(`--cb-right-gap`).
 */

import type { ChangerBarView, ChangerLockReason } from '../input/changerTool'
import type { CatalogId, PaletteIndex, Verb } from '../core/types'
import { t } from '../i18n'
import { itemName } from '../i18n/itemName'
import type { MessageKey } from '../i18n/ko'
import { zoneName } from '../i18n/zoneName'

import { createElement, setAttr, setDisabled, setFlag, setHidden, setText, toCssColor } from './dom'
import { publishSize } from './overlayLayout'

import './changerBar.css'

/* --- 타입 ------------------------------------------------------------------------ */

export type ChangerBarHandlers = Readonly<{
  onVerb: (verb: Verb) => void
  onCatalog: (id: CatalogId) => void
  onColor: (id: PaletteIndex) => void
  onUndo: () => void
  /**
   * 잠긴 동사를 눌렀다. **이미 사전을 거친 문구**를 넘긴다 - 이유 표(`lockReasonText`)는 이 파일 하나에 있어야 하고
   * (`aria-label`도 같은 표를 쓴다) 받는 쪽은 그 말을 자막으로 띄우기만 한다(`hud.showNotice`도 문자열 API다).
   */
  onLocked: (text: string) => void
  /** [다 했다]. `wager`는 스테퍼의 "못 찾을 개수"(0이면 걸지 않는다). */
  onCommit: (wager: number) => void
}>

export type ChangerBarOptions = Readonly<{ mount: HTMLElement; handlers: ChangerBarHandlers }>

export type ChangerBarHandle = Readonly<{
  root: HTMLElement
  render: (view: ChangerBarView) => void
  setVisible: (visible: boolean) => void
  dispose: () => void
}>

/* --- 조각 ------------------------------------------------------------------------ */

/** 잠긴 이유의 문구. verbs의 사유는 에디터와 같은 말(`editor.reject.*`)이다 - 같은 거부가 두 화면에서 다르게 읽히면 안 된다. */
function lockReasonText(reason: ChangerLockReason): string {
  const key: MessageKey = reason === 'budget' || reason === 'no-target' ? `changer.lock.${reason}` : `editor.reject.${reason}`
  return t(key)
}

/** 버튼 하나. 전부 `cb-btn`이라 44px 규칙이 한 선택자에 있다(`changerBar.css`). */
function createButton(className: string, onPress: () => void): HTMLButtonElement {
  const button = createElement('button', `cb-btn ${className}`)
  button.type = 'button'
  button.addEventListener('click', onPress)
  return button
}

/* --- 본체 ------------------------------------------------------------------------ */

/**
 * 띠를 만들어 `mount`에 붙인다. 처음에는 **보이는 상태**이고 내용은 첫 `render`가 채운다.
 * 도구가 세울 때 만들고 수색 진입에 `dispose`한다 - 감춰 두는 띠가 아니다(`stage.ts`의 감춘 도구 금지 규약).
 */
export function createChangerBar(options: ChangerBarOptions): ChangerBarHandle {
  const { handlers } = options
  const root = createElement('section', 'cb-root')
  root.setAttribute('role', 'toolbar')

  /* 위 줄: 내 구획 이름표 · 예산 점 · 되돌리기 · 걸기 스테퍼 · 다 했다 */
  const top = createElement('div', 'cb-top')
  /** 내 구획 이름표(M11). 이름이 없으면(구획 없는 판 · 사전에 없는 id) 통째로 접힌다 - 슬러그를 화면에 내지 않는다. */
  const zone = createElement('div', 'cb-zone')
  const zoneLabel = createElement('span', 'cb-zone__label', '')
  const zoneValue = createElement('span', 'cb-zone__name', '')
  zone.append(zoneLabel, zoneValue)
  const dots = createElement('div', 'cb-dots')
  dots.setAttribute('role', 'status')
  const dotNodes: HTMLElement[] = []
  const undo = createButton('cb-undo', handlers.onUndo)

  /** 걸기 스테퍼(M7). 값은 이 띠가 든다(머리말). 상한은 마지막 뷰의 `budget`이다. */
  let wager = 0
  let wagerMax = 0
  /**
   * 스테퍼가 펴져 있는가. **폰 세로에서만 뜻이 있다** - 데스크톱에서는 CSS가 토글을 감추고 스테퍼를 늘 펴 둔다
   * (`changerBar.css`의 같은 분기). 폰에서 [−] 값 [+] 셋이 늘 서 있으면 띠의 위 줄이 두 겹이 되고, 그 한 겹이
   * 방을 덮는 50px이다. 대부분의 판에서 걸기는 "안 건다"로 끝나므로, 고르지 않는 사람에게는 44px 단추 하나면 된다.
   *
   * 한 번 펴면 다시 접히지 않는다 - 값을 고르는 손이 [+]를 두 번 누르는 사이에 상자가 접히면 그것이 곧 오조작이다.
   */
  let wagerOpen = false
  const wagerBox = createElement('div', 'cb-wager')
  wagerBox.setAttribute('role', 'group')
  const wagerLabel = createElement('span', 'cb-wager__label', '')
  /** 접힌 얼굴. 지금 걸린 값을 그대로 적고, 누르면 스테퍼가 펴진다. 데스크톱에서는 CSS가 통째로 접는다. */
  const wagerToggle = createButton('cb-wager__toggle', () => {
    const hadFocus = wagerToggle.ownerDocument.activeElement === wagerToggle
    wagerOpen = true
    paintWager()
    /*
     * **누른 단추가 사라진다.** 펴지는 순간 CSS가 접힌 얼굴을 `display: none`으로 내리므로, 키보드·스위치로
     * 누른 사람의 포커스가 `<body>`로 날아가 문서 처음부터 다시 Tab을 해야 [−] [+]에 닿는다. 그래서 펴진
     * 스테퍼로 손을 넘긴다 - [+]인 이유는 [−]가 값 0에서 비활성이라 포커스를 못 받기 때문이다.
     * 손가락으로 누른 경우에는 옮기지 않는다(누르지도 않은 단추에 포커스 테두리가 서면 그게 더 낯설다).
     */
    if (hadFocus) wagerInc.focus()
    // 줄 수가 바뀌면 그 위에 서는 카메라 묶음의 높이도 바뀐다. 관측기는 배경 탭에서 오지 않으므로 직접 알린다.
    size.refresh()
  })
  const wagerDec = createButton('cb-wager__step cb-wager__dec', () => setWager(wager - 1))
  // 기호는 U+2212(빼기)와 U+002B다 - 글자가 아니라 수치의 기호라 사전을 거치지 않는다(`juice.formatMultiplier`의 × 와 같은 결정).
  wagerDec.textContent = '\u2212'
  const wagerValue = createElement('span', 'cb-wager__value', '')
  const wagerInc = createButton('cb-wager__step cb-wager__inc', () => setWager(wager + 1))
  wagerInc.textContent = '+'
  wagerBox.append(wagerLabel, wagerToggle, wagerDec, wagerValue, wagerInc)

  const done = createButton('cb-done', () => handlers.onCommit(wager))
  top.append(zone, dots, undo, wagerBox, done)

  /* 동사 팔레트. 버튼은 첫 뷰의 `verbs` 순서로 서고 그 뒤로는 값만 바뀐다. */
  const verbs = createElement('div', 'cb-verbs')
  const verbButtons = new Map<Verb, HTMLButtonElement>()
  /** 마지막 뷰의 동사별 잠금. 버튼의 손은 한 번만 붙으므로 지금 값을 여기서 읽는다. */
  const lastVerbLock = new Map<Verb, ChangerLockReason | null>()

  /* 아래 줄: 안내 한 줄 · 카탈로그 스트립 · 색 팔레트. 셋 중 하나만 보인다. */
  const tray = createElement('div', 'cb-tray')
  const hint = createElement('p', 'cb-hint')
  const strip = createElement('div', 'cb-strip')
  strip.setAttribute('role', 'listbox')
  const catalogButtons = new Map<CatalogId, HTMLButtonElement>()
  const colors = createElement('div', 'cb-colors')
  colors.setAttribute('role', 'listbox')
  const colorButtons = new Map<PaletteIndex, HTMLButtonElement>()
  tray.append(hint, strip, colors)

  root.append(top, verbs, tray)
  options.mount.append(root)

  /*
   * 띠의 높이를 내보낸다. 카메라 묶음(`hud.css`의 `.mc-cluster`)이 이 위로 올라서야 하는데,
   * 전에는 그 관계가 `--cb-right-gap: 56px`(오른쪽으로 비켜 서기)로 되어 있었고 폰에서는 묶음이 화면 폭을
   * 거의 다 써서 비킬 자리가 없었다 - 실측으로 두 상자가 13,800px² 겹쳤다. 옆이 아니라 위아래로 푼다.
   */
  const size = publishSize(root, { height: '--cb-height' })

  /* --- 걸기 스테퍼 --- */

  /** 값을 0..`wagerMax`로 자르고 다시 그린다. 상한 밖의 값은 누를 단추가 없으므로 여기 들어올 길은 상한이 줄어든 경우뿐이다. */
  function setWager(next: number): void {
    wager = Math.min(Math.max(0, next), wagerMax)
    paintWager()
  }

  function paintWager(): void {
    setText(wagerLabel, t('changer.wager.label'))
    const valueText = wager === 0 ? t('changer.wager.none') : t('changer.wager.count', { count: wager })
    setText(wagerValue, valueText)
    // 접힌 얼굴도 같은 값을 적는다 - 두 얼굴이 다른 값을 말하면 어느 쪽이 참인지가 화면에서 갈린다.
    setText(wagerToggle, valueText)
    setAttr(wagerToggle, 'aria-label', t('changer.wager.toggleAria', { value: valueText }))
    /*
     * `aria-expanded`를 걸지 않는다. 펴진 순간 이 단추가 `display: none`이 되므로 참인 상태가 화면에
     * 존재하는 순간이 없다 - 보조기술은 영원히 `false`만 읽게 되고, 그건 상태를 말하는 것이 아니라
     * 틀린 상태를 말하는 것이다. 지금 걸린 값은 이 단추의 이름과 무리(`.cb-wager`)의 이름이 함께 말한다.
     */
    setFlag(wagerBox, 'is-open', wagerOpen)
    setAttr(wagerBox, 'aria-label', wager === 0 ? t('changer.wager.none') : t('changer.wager.aria', { count: wager }))
    setAttr(wagerDec, 'aria-label', t('changer.wager.dec'))
    setAttr(wagerInc, 'aria-label', t('changer.wager.inc'))
    setDisabled(wagerDec, wager <= 0)
    setDisabled(wagerInc, wager >= wagerMax)
    setFlag(wagerBox, 'is-on', wager > 0)
    // [다 했다]의 이름이 걸기를 말한다 - 걸고 끝내는지 그냥 끝내는지가 보조기술에도 들려야 한다.
    setAttr(done, 'aria-label', wager > 0 ? t('changer.doneWagerAria', { count: wager }) : t('changer.doneAria', { left: lastLeft }))
  }

  /** 마지막 뷰의 남은 개수. [다 했다]의 이름이 걸기 유무에 따라 둘 중 하나를 쓰므로 스테퍼가 바뀔 때도 필요하다. */
  let lastLeft = 0

  /* --- 내 구획 --- */

  function paintZone(view: ChangerBarView): void {
    const name = zoneName(view.zoneId)
    setHidden(zone, name === undefined)
    if (name === undefined) return
    setText(zoneLabel, t('zone.mine'))
    setText(zoneValue, name)
    setAttr(zone, 'aria-label', t('zone.mineAria', { name }))
  }

  /* --- 점 --- */

  function paintDots(view: ChangerBarView): void {
    if (dotNodes.length !== view.budget) {
      dotNodes.length = 0
      dots.replaceChildren()
      for (let index = 0; index < view.budget; index += 1) {
        const dot = createElement('i', 'cb-dot')
        dotNodes.push(dot)
        dots.append(dot)
      }
    }
    dotNodes.forEach((dot, index) => setFlag(dot, 'is-on', index < view.used))
    setAttr(dots, 'aria-label', t('changer.budgetAria', { used: view.used, budget: view.budget }))
  }

  /* --- 동사 --- */

  function paintVerbs(view: ChangerBarView): void {
    for (const item of view.verbs) {
      let button = verbButtons.get(item.verb)
      if (button === undefined) {
        // 잠금은 **누른 뒤에** 갈린다 - 그래야 왜 안 되는지를 말할 수 있다(머리말). 마지막 뷰의 잠금을 본다.
        const created = createButton('cb-verb', () => {
          const locked = lastVerbLock.get(item.verb) ?? null
          if (locked === null) handlers.onVerb(item.verb)
          else handlers.onLocked(lockReasonText(locked))
        })
        created.dataset['verb'] = item.verb
        verbButtons.set(item.verb, created)
        verbs.append(created)
        button = created
      }
      const name = t(`verb.${item.verb}`)
      setText(button, name)
      lastVerbLock.set(item.verb, item.locked)
      // `disabled`가 아니다(머리말) - 눌려야 이유를 말한다. 회색과 `not-allowed`는 CSS가 같은 모양으로 그린다.
      // 풀린 잠금은 `aria-disabled="false"`가 아니라 **속성 제거**다 - `false`를 읽는 보조기술이 있다.
      if (item.locked === null) button.removeAttribute('aria-disabled')
      else setAttr(button, 'aria-disabled', 'true')
      setFlag(button, 'is-active', item.active)
      setAttr(button, 'aria-pressed', item.active ? 'true' : 'false')
      // 잠긴 이유는 이름 뒤에 붙는다 - 버튼은 제자리에 남고 왜 안 되는지를 말한다(머리말).
      setAttr(button, 'aria-label', item.locked === null ? name : t('changer.lockedAria', { verb: name, reason: lockReasonText(item.locked) }))
    }
  }

  /* --- 스트립 · 색 --- */

  function paintCatalog(view: ChangerBarView): void {
    const items = view.catalog
    setHidden(strip, items === null)
    if (items === null) return
    setAttr(strip, 'aria-label', t('changer.catalogAria'))
    for (const item of items) {
      let button = catalogButtons.get(item.id)
      if (button === undefined) {
        const created = createButton('cb-chip', () => handlers.onCatalog(item.id))
        created.setAttribute('role', 'option')
        const swatch = createElement('i', 'cb-chip__swatch')
        swatch.setAttribute('aria-hidden', 'true')
        const label = createElement('span', 'cb-chip__name')
        created.append(swatch, label)
        catalogButtons.set(item.id, created)
        strip.append(created)
        button = created
      }
      const swatch = button.firstElementChild
      if (swatch instanceof HTMLElement) swatch.style.background = toCssColor(item.colorHex)
      // 이름은 사전이 낸다 - 뷰가 실어 오는 것은 id뿐이다(`changerToolTypes.ts`의 규칙).
      const name = itemName(item.id) ?? ''
      const label = button.lastElementChild
      if (label instanceof HTMLElement) setText(label, name)
      setAttr(button, 'aria-label', name)
      setAttr(button, 'aria-selected', item.selected ? 'true' : 'false')
      setFlag(button, 'is-selected', item.selected)
    }
  }

  function paintColors(view: ChangerBarView): void {
    const items = view.colors
    setHidden(colors, items === null)
    if (items === null) return
    setAttr(colors, 'aria-label', t('changer.colorsAria'))
    for (const item of items) {
      let button = colorButtons.get(item.id)
      if (button === undefined) {
        const created = createButton('cb-swatch', () => handlers.onColor(item.id))
        created.setAttribute('role', 'option')
        created.style.background = toCssColor(item.hex)
        colorButtons.set(item.id, created)
        colors.append(created)
        button = created
      }
      setAttr(button, 'aria-label', t('editor.colorAria', { name: item.name }))
      setAttr(button, 'aria-selected', item.selected ? 'true' : 'false')
      setFlag(button, 'is-selected', item.selected)
      setDisabled(button, item.locked)
    }
  }

  /* --- 안내 --- */

  function hintText(view: ChangerBarView): string {
    const name = itemName(view.subjectItemId) ?? ''
    switch (view.mode) {
      case 'idle':
        return t('changer.hint.idle')
      case 'selected':
        return t('changer.hint.selected', { name })
      case 'moving':
        return t('changer.hint.moving', { name })
      case 'adding':
        return t('changer.hint.adding', { name })
    }
  }

  return {
    root,

    render(view: ChangerBarView): void {
      setAttr(root, 'aria-label', t('changer.barAria'))
      paintZone(view)
      paintDots(view)
      paintVerbs(view)
      paintCatalog(view)
      paintColors(view)
      setText(hint, hintText(view))
      // 스트립이나 팔레트가 펴져 있으면 안내는 접는다 - 아래 줄은 한 가지만 말한다.
      setHidden(hint, view.catalog !== null || view.colors !== null)

      setText(undo, t('changer.undo'))
      const undoName = itemName(view.undoItemId)
      setDisabled(undo, undoName === undefined)
      setAttr(undo, 'aria-label', undoName === undefined ? t('changer.undo') : t('changer.undoAria', { name: undoName }))

      setText(done, t('changer.done'))
      lastLeft = view.left
      // 상한이 줄면(뷰의 변화 개수가 바뀌는 일은 없지만 방어) 값도 따라 내려온다. 그 뒤 [다 했다]의 이름까지 여기서 새로 칠한다.
      wagerMax = Math.max(0, view.budget)
      setWager(wager)

      // 줄 수가 바뀌면 그 위에 서는 카메라 묶음의 높이도 바뀐다. 관측기는 배경 탭에서 오지 않으므로 여기서 직접 알린다.
      size.refresh()
    },

    setVisible(visible: boolean): void {
      setHidden(root, !visible)
      // 접힌 상자를 관측기가 놓칠 수 있다. 남은 높이만큼 카메라 묶음이 떠 있게 되므로 직접 다시 잰다.
      size.refresh()
    },

    dispose(): void {
      size.dispose()
      root.remove()
    },
  }
}
